import { object, string } from 'yup';
import HttpStatus from 'http-status-codes';

export const SchemaError = {
  [HttpStatus.BAD_REQUEST]: {
    signature: 'Sign your full name as it appears on your account'
  }
};

export default object().shape({
  signature: string().matches(
    /\S+\s\S+$/,
    'Enter your full name (and check for typos)'
  )
});
